// DevWorkspaceToolbar.js — Barre workspace (init, save, statut)

import React from 'react';
import { FolderGit2, Save, Loader2, RefreshCw, Pencil, Eye, Monitor } from 'lucide-react';
import './devCockpit.css';

export default function DevWorkspaceToolbar({
    workspace,
    selectedPath,
    language,
    dirty,
    viewMode,
    onInit,
    onSave,
    onRefresh,
    onSetViewMode,
    onRequestApp,
    initializing,
    saving,
    fileLoading,
}) {
    const status = workspace?.status || 'empty';
    const statusLabel = {
        empty: 'Vide',
        cloning: 'Clone…',
        ready: 'Prêt',
        error: 'Erreur',
    }[status] || status;

    const statusClass = status === 'ready' ? 'dev-workspace__status--ready'
        : status === 'error' ? 'dev-workspace__status--error'
            : 'dev-workspace__status--pending';

    return (
        <div className="dev-workspace__toolbar">
            <span className="dev-workspace__toolbar-label">
                <FolderGit2 size={13} />
                Workspace
            </span>
            <span className={`dev-workspace__status ${statusClass}`} title={status === 'error' ? workspace?.last_error : undefined}>
                {status === 'empty' ? 'Vide — initialiser' : statusLabel}
            </span>

            <div className="dev-workspace__file-info">
                {selectedPath ? (
                    <>
                        <span className={`dev-workspace__breadcrumb${dirty ? ' dev-workspace__breadcrumb--dirty' : ''}`}>
                            {selectedPath}{dirty ? ' •' : ''}
                        </span>
                        {language && language !== 'plaintext' && (
                            <span className="dev-workspace__pill">{language}</span>
                        )}
                        <span className="dev-workspace__pill dev-workspace__pill--mode">
                            {viewMode === 'edit' ? 'Édition' : viewMode === 'app' ? 'App' : 'Aperçu'}
                        </span>
                    </>
                ) : (
                    <span className="dev-workspace__breadcrumb dev-workspace__breadcrumb--empty">
                        Sélectionnez un fichier
                    </span>
                )}
            </div>

            <div className="dev-workspace__actions">
                {status !== 'ready' && (
                    <button
                        type="button"
                        onClick={onInit}
                        disabled={initializing || status === 'cloning'}
                        className="dev-btn dev-btn--primary"
                    >
                        {initializing ? <Loader2 size={12} style={{ animation: 'spin 1s linear infinite' }} /> : <FolderGit2 size={12} />}
                        Init clone
                    </button>
                )}
                <button type="button" onClick={onRefresh} disabled={status !== 'ready'} className="dev-btn dev-btn--icon" title="Rafraîchir">
                    <RefreshCw size={12} />
                </button>
                {status === 'ready' && (
                    <div className="dev-workspace__mode-group">
                        <button
                            type="button"
                            onClick={() => onSetViewMode('file')}
                            className={`dev-btn dev-btn--mode${viewMode === 'file' ? ' dev-btn--mode-active' : ''}`}
                            title="Aperçu fichier"
                        >
                            <Eye size={12} />
                            Aperçu
                        </button>
                        <button
                            type="button"
                            onClick={() => onSetViewMode('edit')}
                            disabled={!selectedPath || fileLoading}
                            className={`dev-btn dev-btn--mode${viewMode === 'edit' ? ' dev-btn--mode-active' : ''}`}
                            title="Éditer le fichier"
                        >
                            <Pencil size={12} />
                            Éditer
                        </button>
                        <button
                            type="button"
                            onClick={onRequestApp}
                            className={`dev-btn dev-btn--mode${viewMode === 'app' ? ' dev-btn--mode-active' : ''}`}
                            title="Preview application (build CRA)"
                        >
                            <Monitor size={12} />
                            App
                        </button>
                    </div>
                )}
                <button
                    type="button"
                    onClick={onSave}
                    disabled={!dirty || !selectedPath || saving || viewMode !== 'edit'}
                    className="dev-btn dev-btn--primary"
                >
                    {saving ? <Loader2 size={12} style={{ animation: 'spin 1s linear infinite' }} /> : <Save size={12} />}
                    Enregistrer
                </button>
            </div>
        </div>
    );
}
